import clsx from "clsx"
import { FC } from "react"
import { OutlinedText } from "@/ui/OutlinedText"
import styles from "./AppVersion.module.scss"

interface IAppVersion {}

export const AppVersion: FC<IAppVersion> = () => {
  return (
    <OutlinedText className={clsx(styles.AppVersion)}>
      {window.Telegram.WebApp.platform} - v{import.meta.env.VITE_APP_VERSION}
    </OutlinedText>
  )
}
